import React from "react";
import {
  ItemDonationModel,
  ItemMembershipModel,
  ItemServiceModel,
  ProductItemModel,
  RelatedItemsCategoriesModel,
  RelatedSectionModel,
} from "../../../shared/models";
import TrioBallsIcon from "../../../../../../images/common/ball-trio.svg";
import ServiceIcon from "../../../../../../images/common/service.svg";
import ProductIcon from "../../../../../../images/common/product.svg";
import styled from "styled-components";
import {
  CustomLabel,
  FlexContainer,
  Loader,
  UtilityMethods,
} from "@mindmemobile/mm-shared-global";
import { SystemItemTypes } from "../../../shared/enums";
import { PropertyButtons } from "../../../shared/styles";
import DonationIcon from "../../../../../../images/donation/donating-hands.svg";

interface DeletePopUpProps {
  selectedItem:
    | ProductItemModel
    | ItemServiceModel
    | ItemMembershipModel
    | ItemDonationModel
    | null;
  itemType: SystemItemTypes;
  purchasedItemDetails: { id: string; lastPurchase: string } | null;
  isLoading?: boolean;
}

export const DeleteItemPopupWrapper = styled.div`
  > div {
    /* display: flex; */
    /* align-items: center; */
    margin-bottom: 25px;
    > div > ${CustomLabel} {
      &:first-child {
        margin-right: 10px;
        width: 150px;
      }
      &:last-child {
        flex: 1 1 0;
      }
    }
    .item-icon {
      img {
        height: 20px;
        width: 20px;
      }
    }
  }
`;

const DeletePopUp: React.FC<DeletePopUpProps> = ({
  selectedItem,
  itemType,
  purchasedItemDetails,
  isLoading,
}) => {
  //if (!selectedItem) return null;

  function getCategoriesToShow(
    relatedData: RelatedSectionModel
  ): RelatedItemsCategoriesModel[] | undefined {
    if (!relatedData) return undefined;

    const categories = [
      relatedData.requiredItems,
      relatedData.recommendedItems,
      relatedData.includedItems,
    ]
      .filter((item) => item.showCategories)
      .flatMap((item) => item.categories);

    const uniqueCategories = Array.from(
      new Map(categories.map((c) => [c.id, c])).values()
    );

    return uniqueCategories.length ? uniqueCategories : undefined;
  }

  const getIcon = (type: keyof typeof SystemItemTypes) => {
    switch (type) {
      case SystemItemTypes.Product:
        return <img src={ProductIcon} />;
      case SystemItemTypes.Membership:
        return <img src={TrioBallsIcon} />;
      case SystemItemTypes.Service:
        return <img src={ServiceIcon} />;
      case SystemItemTypes.Donation:
        return <img src={DonationIcon} />;
      default:
        return null;
    }
  };

  const categoriesToShow = selectedItem?.relatedSectionData
    ? getCategoriesToShow(selectedItem.relatedSectionData)
    : null;

  const row = (
    label: string,
    rightSide: React.ReactNode,
    spacing: number = 20
  ) => {
    return (
      <div>
        <FlexContainer alignItems="center" spacing={spacing}>
          <CustomLabel>{label}</CustomLabel>
          {rightSide}
        </FlexContainer>
      </div>
    );
  };

  if (isLoading) {
    return (
      <DeleteItemPopupWrapper>
        {new Loader(true).loaderComponent}
      </DeleteItemPopupWrapper>
    );
  }

  if (selectedItem === null) return null;
  return (
    <DeleteItemPopupWrapper>
      <>
        {row(
          "Item Name",
          <CustomLabel>{selectedItem.detailSection.name}</CustomLabel>
        )}
        {row(
          "Item Type",
          <FlexContainer spacing={10} className="item-icon">
            {getIcon(itemType)}
            <CustomLabel>{itemType}</CustomLabel>
          </FlexContainer>
        )}
        {categoriesToShow &&
          row(
            "Categories",
            <FlexContainer fxWrap="wrap" spacing={15}>
              {categoriesToShow.map((category) => (
                <PropertyButtons key={category.id}>
                  {category.name}
                </PropertyButtons>
              ))}
            </FlexContainer>
          )}
        {row(
          "Last Purchased",
          <CustomLabel>
            {purchasedItemDetails?.lastPurchase
              ? UtilityMethods.formatDateInStringWithTime(
                  new Date(purchasedItemDetails.lastPurchase)
                )
              : "Never"}
          </CustomLabel>
        )}
        {row(
          "Created",
          <CustomLabel>
            {selectedItem?.detailSection.createdDate
              ? selectedItem.detailSection.createdDate.toDateString()
              : "Never"}
          </CustomLabel>
        )}
        <CustomLabel
          textAlign="center"
          color="red"
          margin="20px 0px 0px"
          className="full-width"
        >
          {purchasedItemDetails?.lastPurchase ? (
            <span>
              Item will no longer be available for new purchases,
              <br /> but will still exist on existing orders.
            </span>
          ) : (
            <span>
              Item will be permanently deleted and no longer <br /> be available
              for new purchases
            </span>
          )}
        </CustomLabel>
      </>
    </DeleteItemPopupWrapper>
  );
};

export default DeletePopUp;
